import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { iconPositions } from '../../../../_constants/input.constant';

@Component({
    selector: 'lokos-text-area',
    templateUrl: './text-area.component.html',
    styleUrl: './text-area.component.scss',
    standalone: false,
})
export class TextAreaComponent implements OnChanges {
    @Input({ required: false }) cols = false;
    @Input({ required: false }) control: FormControl = new FormControl();
    @Input({ required: false }) disabled = false;
    @Input({ required: false }) iconPath = '';
    @Input({ required: false }) iconPosition = '';
    @Input({ required: false }) isIcon = false;
    @Input({ required: false }) label = '';
    @Input({ required: false }) readonly = false;
    @Input({ required: false }) rows = 4;
    @Input({ required: false }) maxlength = 0;
    @Input({ required: false }) type = 'text';
    @Input({ required: false }) value = '';
    @Input({ required: true }) placeholder = 'placeholder';
    @Input({ required: true }) required = false;

    @Output() afterInput = new EventEmitter();
    @Output() afterBlur = new EventEmitter();
    @Output() afterFocus = new EventEmitter();

    iconPositions = iconPositions;

    constructor(private translate: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }

    getErrorMessage() {
        const label = this.label
            ? this.translate.instant(this.label)
            : this.translate.instant('thisField');

        if (this.control.hasError('required')) {
            return `${label} ${this.translate.instant('isRequired')}}`;
        }
        if (this.control.hasError('minlength')) {
            const requiredLen =
                this.control.getError('minlength')?.requiredLength;
            return `${label} ${this.translate.instant('shouldBeAtLeast')} ${requiredLen} ${this.translate.instant('charactersLong')}`;
        }
        if (this.control.hasError('maxlength')) {
            const requiredLen =
                this.control.getError('maxlength')?.requiredLength;
            return `${label} ${this.translate.instant('shouldBeAtMost')} ${requiredLen} ${this.translate.instant('charactersLong')}`;
        }
        if (this.control.hasError('pattern')) {
            return `${this.translate.instant('invalidFormatFor')} ${label}`;
        }
        return '';
    }
}
